import React from 'react';
import PropTypes from 'prop-types';

import { TableDeleteOption } from 'components/common/Elements/Elements';
import classes from './RemoteReleases.module.scss';

const RemoteReleases = ({ dataDelRelease = [], onReestablish }) => {
  return (
    <div className={classes.wrapBodyModal}>
      <div className={classes.wrapForMobile}>
        <TableDeleteOption
          icon={'Icn_Restore_from_trash'}
          dataDelRelease={dataDelRelease}
          clickIconRow={onReestablish}
          isDeletable={true}
          className={classes.table_mobile}
        />
      </div>
    </div>
  );
};

RemoteReleases.propTypes = {
  dataDelRelease: PropTypes.array,
  onReestablish: PropTypes.func
};

export default RemoteReleases;
